import { ca } from '@cian/analytics';

import { IJsonQuery } from '../../../../packages/api-models/common/json_query';

interface IEmptyListingSuggestionOffer {
  id: number;
  mlSuggestionsInfiniteSearchResult?: { modelVersion: string } | null;
}

interface ITrackEmptyListingSuggestionsShowParams {
  offers: IEmptyListingSuggestionOffer[];
  jsonQuery: IJsonQuery | null;
}

interface ITrackEmptyListingSuggestionsClickParams {
  offer: IEmptyListingSuggestionOffer;
  position: number;
  jsonQuery: IJsonQuery | null;
}

export const trackEmptyListingSuggestionsShow = ({ offers, jsonQuery }: ITrackEmptyListingSuggestionsShowParams) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'page',
    action: 'newpage_infinite_search',
    label: '',
    modelVersion: offers[0]?.mlSuggestionsInfiniteSearchResult?.modelVersion,
    products: offers.map((offer, index) => ({
      id: offer.id,
      offerType: 'offer',
      position: index + 1,
    })),
    page: {
      pageType: 'ListingHybrid',
      siteType: 'desktop',
    },
    sc: jsonQuery,
  });
};

export const trackEmptyListingSuggestionsClick = ({
  offer,
  position,
  jsonQuery,
}: ITrackEmptyListingSuggestionsClickParams) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'to_card_infinite_search',
    label: 'card_detail_in_newlist',
    modelVersion: offer.mlSuggestionsInfiniteSearchResult?.modelVersion,
    products: [
      {
        id: offer.id,
        offerType: 'offer',
        position,
      },
    ],
    page: {
      pageType: 'ListingHybrid',
      siteType: 'desktop',
    },
    sc: jsonQuery,
  });
};
